module.exports = __webpack_public_path__ + "img/tees.ff6205f8.png";